// web/src/registry/features/_part-2.ts —— FEATURES 的第 2/6 段（25 个元素：inbound / bot / assist / quality）
// 拆自 web/src/registry/features.ts（元素原样搬运、顺序不变）；由入口按顺序展开组合，故本片是**内部片**，不对外导出。
import type { Feature } from '../features';

export const FEATURES_PART_2: Feature[] = [

  {
    id: 'inbound.analytics',
    title: '呼入分析',
    domain: 'inbound',
    scope: 'domain',
    type: 'analytics',
    route: '/inbound/analytics',
    orphan: true,
    legacyLocations: ['/report'],
    permission: null,
    priority: 'P1',
    issue: '已收敛到「运营分析 → 报表中心」，不再占业务域导航',
  },

  // 机器人
  {
    id: 'bot.robots',
    title: '语音机器人',
    domain: 'bot',
    scope: 'domain',
    type: 'resource',
    route: '/bot/robots',
    legacyLocations: ['/bot'],
    permission: 'bot.robots',
    nav: { section: 'business', group: 'bot', order: 1 },
    priority: 'P1',
    issue: '原「AI机器人配置」：语音通道的机器人本体；与「在线机器人」按渠道并列，两者仍是两张表（ai_bot / chat_bot），字段高度平行',
  },
  {
    id: 'bot.robot.detail',
    title: '机器人详情',
    domain: 'bot',
    scope: 'domain',
    type: 'resource',
    route: '/bot/robots/:id',
    permission: 'bot.robots',
    priority: 'P1',
  },
  {
    id: 'bot.chat-robots',
    title: '在线机器人',
    domain: 'bot',
    scope: 'domain',
    type: 'resource',
    route: '/bot/chat-robots',
    legacyLocations: ['/chat/bot', '/chatbot'],
    permission: 'chat.bot',
    nav: { section: 'business', group: 'bot', order: 2 },
    priority: 'P1',
    issue: '文字渠道机器人：原挂在「在线客服」一级域（机器人本体与语音机器人被拆到两个一级模块），按归属迁入智能机器人；权限码仍为 chat.bot（权限码整体重构时一并改名）',
  },
  {
    id: 'bot.intents',
    title: '意图识别',
    domain: 'bot',
    scope: 'platform',
    type: 'config',
    route: '/bot/intents',
    legacyLocations: ['/intent'],
    permission: 'bot.intents',
    nav: { section: 'business', group: 'bot', order: 3 },
    priority: 'P0',
    issue: '意图跨 bot/chat/assist 通道共享，却挂在 bot 一级；是否 PLATFORM 待确认。页签：意图词表 / 通用规则词表 / 统计分析 / 意图测试台',
  },
  {
    id: 'bot.ruleword',
    title: '通用规则词表',
    domain: 'bot',
    scope: 'domain',
    type: 'config',
    route: '/bot/intents/ruleword',
    legacyLocations: ['/system/sys-settings?tab=ruleword', '/bot/ruleword'],
    permission: 'bot.ruleword',
    priority: 'P1',
    issue: '行为判定词表（哪些话算问候/告别/否定/风险/承诺度）曾是独立菜单，现为「意图识别」页签（与意图词表贴在一起才对得上「两套词表别混填」的口径）；词表可运营，但改动影响判定，故仅 admin',
  },
  {
    id: 'bot.flow',
    title: '对话流程（使用关系）',
    domain: 'bot',
    scope: 'domain',
    type: 'config',
    route: '/bot/robots/:id/flow',
    legacyLocations: ['/system/flows'],
    permission: 'workflow.flows',
    priority: 'P0',
    issue: '此处只表达“该机器人使用/编辑哪个流程”；流程资源所有权归 workflow.flows（PLATFORM）',
  },
  {
    id: 'bot.voice',
    title: '语音策略',
    domain: 'bot',
    scope: 'domain',
    type: 'config',
    route: '/bot/robots/:id/voice',
    permission: 'bot.voice',
    priority: 'P1',
    issue: '机器人级语音覆盖（小设置点）；全局默认见 bot.voice.defaults，两者互不覆盖',
  },
  {
    id: 'bot.voice.defaults',
    title: '语音行为默认',
    domain: 'bot',
    scope: 'domain',
    type: 'config',
    route: '/bot/voice-defaults',
    permission: 'bot.voice-defaults',
    nav: { section: 'business', group: 'bot', order: 5 },
    priority: 'P1',
    issue: '机器人语音链路全局默认（静音垫/静默/垫话/ASR 修正），机器人级可覆盖；独立于 bot.voice',
  },
  {
    id: 'bot.models',
    title: '模型策略',
    domain: 'bot',
    scope: 'domain',
    type: 'config',
    route: '/bot/robots/:id/models',
    legacyLocations: ['/aicenter'],
    permission: 'bot.robots',
    priority: 'P0',
    issue: '模型“使用关系”原混入 /aicenter 平台资源页；资源所有权归平台、使用关系归业务',
  },
  {
    id: 'bot.analytics',
    title: '机器人分析',
    domain: 'bot',
    scope: 'domain',
    type: 'analytics',
    route: '/bot/analytics',
    orphan: true,
    legacyLocations: ['/report'],
    permission: null,
    priority: 'P1',
    issue: '已收敛到「运营分析 → 报表中心」，不再占业务域导航',
  },

  // 坐席辅助
  {
    id: 'assist.scripts',
    title: '话术库',
    domain: 'assist',
    scope: 'domain',
    type: 'resource',
    route: '/assist/scripts',
    legacyLocations: ['/scripts'],
    permission: 'assist.scripts',
    nav: { section: 'business', group: 'assist', order: 1 },
    priority: 'P2',
  },
  {
    id: 'assist.products',
    title: '营销产品',
    domain: 'assist',
    scope: 'domain',
    type: 'resource',
    route: '/assist/products',
    legacyLocations: ['/assist/products'],
    permission: 'assist.products',
    nav: { section: 'business', group: 'assist', order: 2 },
    priority: 'P2',
  },
  {
    id: 'assist.settings',
    title: '坐席辅助设置',
    domain: 'assist',
    scope: 'domain',
    type: 'config',
    route: '/assist/settings',
    legacyLocations: ['/assist/config'],
    permission: 'assist.settings',
    nav: { section: 'business', group: 'assist', order: 4 },
    priority: 'P1',
    issue: '知识库模型绑定从此页迁出（回 knowledge）',
  },
  {
    id: 'assist.analytics',
    title: '辅助分析',
    domain: 'assist',
    scope: 'domain',
    type: 'analytics',
    route: '/assist/analytics',
    orphan: true,
    permission: null,
    priority: 'P2',
    issue: '原无分析能力（缺口），按需新增，不默认假设必须存在',
  },

  // 智能质检
  {
    id: 'quality.reports',
    title: '质检报告',
    domain: 'quality',
    scope: 'domain',
    type: 'record',
    route: '/quality/reports',
    orphan: true,
    legacyLocations: ['/quality'],
    permission: 'quality.reports',
    priority: 'P1',
    issue: '原为 /quality 页内 Tab，与管理面混载；已并入「抽检」组（报告）',
  },
  {
    id: 'quality.realtime',
    title: '实时质检',
    domain: 'quality',
    scope: 'domain',
    type: 'workspace',
    route: '/quality/realtime',
    legacyLocations: ['/quality?tab=realtime', '/quality/analytics?tab=realtime'],
    permission: 'quality.realtime',
    nav: { section: 'business', group: 'quality', order: 1 },
    priority: 'P1',
    issue: '原为「质检分析」页内 Tab，提升为独立二级菜单：通话/会话进行中的质检告警流水',
  },
  {
    id: 'quality.flow-reports',
    title: '流程质检',
    domain: 'quality',
    scope: 'domain',
    type: 'analytics',
    route: '/quality/flow-reports',
    legacyLocations: ['/quality?tab=flow-reports', '/quality/analytics?tab=flow-reports'],
    permission: 'quality.flow-reports',
    priority: 'P1',
    issue: '并入「质检详情」页内子 tab：按工单走完整流程评质量（非单独侧栏入口）',
  },
  {
    id: 'quality.sampling',
    title: '质检详情',
    domain: 'quality',
    scope: 'domain',
    type: 'resource',
    route: '/quality/sampling',
    legacyLocations: ['/quality?tab=sampling'],
    // 通用入口：管理端持 quality.sampling 看全量；坐席持 quality.reports 进入则按数据范围看本人报告/申诉；流程质检并入本页
    permission: ['quality.sampling', 'quality.reports', 'quality.flow-reports'],
    nav: { section: 'business', group: 'quality', order: 5 },
    priority: 'P1',
  },
  {
    id: 'quality.samples',
    title: '样本回流',
    domain: 'quality',
    scope: 'domain',
    type: 'governance',
    route: '/quality/samples',
    orphan: true,
    legacyLocations: ['/quality?tab=samples'],
    permission: 'quality.sampling',
    priority: 'P1',
  },
  {
    id: 'quality.rules',
    title: '规则与规则集',
    domain: 'quality',
    scope: 'domain',
    type: 'config',
    route: '/quality/rules',
    legacyLocations: ['/quality?tab=rules'],
    permission: 'quality.rules',
    nav: { section: 'business', group: 'quality', order: 4 },
    priority: 'P1',
  },
  {
    id: 'quality.jobs',
    title: '质检任务',
    domain: 'quality',
    scope: 'domain',
    type: 'workspace',
    route: '/quality/jobs',
    legacyLocations: ['/quality?tab=jobs'],
    permission: 'quality.jobs',
    nav: { section: 'business', group: 'quality', order: 2 },
    priority: 'P1',
    issue: '原为「质检分析」页内 tab（批量质检），提升为二级菜单：圈定数据 + 添加规则集执行批量质检',
  },
  {
    id: 'quality.templates',
    title: '质检模板',
    domain: 'quality',
    scope: 'domain',
    type: 'config',
    route: '/quality/templates',
    // 该地址此前是「旧规则模板」的旧地址重定向目标（App.tsx 的 CANONICAL_REDIRECTS），
    // 本 Feature 落地时一并删除该重定向，原地址记入 quality.rules 的 legacyLocations 追溯。
    permission: 'quality.templates',
    nav: { section: 'business', group: 'quality', order: 3 },
    priority: 'P1',
    issue: '新增：组合若干规则集并配权重（合计 100），是 v2 计分口径的权重唯一来源；实时模板置顶、在线会话模板可从语音复制后微调',
  },
  {
    id: 'quality.settings',
    title: '质检设置',
    domain: 'quality',
    scope: 'domain',
    type: 'config',
    route: '/quality/settings',
    permission: 'quality.settings',
    nav: { section: 'business', group: 'quality', order: 7 },
    priority: 'P2',
    issue: '页内保留「质检与录音」：会话质检采样与内线互拨录音白名单',
  },];
